// vendor
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { useDynamicLoad } from './dynamicLoad.hook';
import { history } from '../../store/configureStore';

import styles from './dynamicLoad.styles.scss';

const MICROFRONTEND_SUFFIX = '-microfrontend';
const MICROFRONTEND_WHITEBOARD = 'microfrontend-whiteboard';

const Microfrontend = ({ vertical }) => {
    const microfrontendWhiteboardElId = `${vertical.id}${MICROFRONTEND_WHITEBOARD}`;
    const microfrontendElId = `${vertical.id}${MICROFRONTEND_SUFFIX}`;

    const { prepareVertical } = useDynamicLoad(vertical, history);

    useEffect(() => {
        prepareVertical();
        return () => {
            const whiteboard = document.getElementById(microfrontendWhiteboardElId);
            const firstWhiteboardChildrenID = _.get(whiteboard, 'children', 0, 'id');

            firstWhiteboardChildrenID && ReactDOM.unmountComponentAtNode(whiteboard.children[0]);
        };
    },[]);

    return (
        <div className={styles['microfrontend-whiteboard']} id={microfrontendWhiteboardElId}>
            <div className={styles['microfrontend-container']} id={microfrontendElId} />
        </div>
    );
};

Microfrontend.propTypes = {
    vertical: PropTypes.shape({
        proxy: PropTypes.string,
        id: PropTypes.string
    }),
};

export default Microfrontend;
